'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Should only provide drop functionality. Nothing more. Use Uploading component to show progress.


function FileInput(_ref) {
  var accept = _ref.accept,
      message = _ref.message,
      onSelect = _ref.onSelect,
      uploadStarted = _ref.uploadStarted; // Display empty div when upload has started.

  if (uploadStarted) return _react2.default.createElement('div', {
    className: 'uploading'
  });
  return _react2.default.createElement('div', {
    className: 'fileInput'
  }, _react2.default.createElement('p', null, message), _react2.default.createElement('input', {
    accept: accept,
    type: 'file',
    name: 'fileselect',
    onChange: onSelect,
    value: ''
  }));
}

FileInput.propTypes = {
  accept: _propTypes2.default.string,
  // id: PropTypes.string,
  message: _propTypes2.default.string.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  uploadStarted: _propTypes2.default.bool
};
FileInput.defaultProps = {
  message: 'Select a new file to upload.',
  multiple: false
};
exports.default = FileInput;
module.exports = exports['default'];